import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M3.958 6.458c0-.92.747-1.666 1.667-1.666h8.75c.92 0 1.667.746 1.667 1.666v7.084c0 .92-.747 1.666-1.667 1.666h-8.75c-.92 0-1.667-.746-1.667-1.666V6.458Zm.209 2.084h11.666m-9.375 3.333h2.084m4.583 0h.417" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);